<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <div class="col-md-3 col-6">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </div>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Disclaimer", value: "disclaimer" },
      { text: "Action", value: "actions", sortable: false },
    ],
    items: [],
  }),

  created() {
    this.initialize();
  },
  mounted() {},

  methods: {
    initialize() {
      this.items = [];
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_ROOT_API + "admin/fintalk-disclaimer", {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          this.items = response.data;
        });
    },

    editItem(item) {
      this.$router
        .push({ path: "/admin/edit-fintalk-disclaimer/" + btoa(item.id) })
        .catch(() => {});
    },
  },
};
</script>
<style>
.compaign-container {
  margin-top: 0px;
  float: left;
}
.active-class {
  color: rgb(35, 199, 35);
  font-size: 16px;
  font-weight: bold;
}
.inactive-class {
  font-size: 16px;
  font-weight: bold;
  color: dimgrey;
}
</style>
